//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class LogConstants
{
	public static maxLogMessageLength: number = 2000;
	public static logErrorApiSecretHeaderName: string = `X-Log-Error-Secret`;
}
